import { Component, inject } from '@angular/core';
import { ViewportScroller, CommonModule } from '@angular/common';

@Component({
  selector: 'app-mobile-buttons',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './mobile-buttons.component.html',
})
export class MobileButtonsComponent {
  private scroller = inject(ViewportScroller);

  scrollToElement(id: string) {
    this.scroller.scrollToAnchor(id);
  }
}
